export const modules = [
  {
    id: 'authentication',
    name: 'Authentication',
    submodules: [
      { id: 'overview', name: 'Overview & How It Works', path: '/authentication/overview', icon: '🔐' },
      { id: 'internal', name: 'React / Internal Apps',   path: '/authentication/internal', icon: '⚛️' },
      { id: 'external', name: 'External APIs (n8n, Postman, Retell)', path: '/authentication/external', icon: '🔗' },
    ],
  },
  {
    id: 'guide',
    name: 'Developer Guide',
    submodules: [
      { id: 'structure', name: 'Backend Project Structure',    path: '/guide/structure', icon: '🏗️' },
      { id: 'client',    name: 'Frontend Project Structure',    path: '/guide/client',    icon: '⚛️' },
    ],
  },
  {
    id: 'crm',
    name: 'CRM Module',
    submodules: [
      { id: 'leads',           name: 'Leads',           file: 'CRM_Leads.json',           icon: '📋' },
      { id: 'ecoleads',        name: 'Eco Leads',       file: 'CRM_Ecoleads.json',         icon: '🌱' },
      { id: 'contacts',        name: 'Contacts',        file: 'CRM_Contacts.json',         icon: '👥' },
      { id: 'conversation',    name: 'Conversation',    file: 'CRM_Conversation.json',     icon: '💬' },
      { id: 'list',            name: 'Lists',           file: 'CRM_List.json',             icon: '📝' },
      { id: 'mailtemplate',    name: 'Mail Template',   file: 'CRM_MailTemplate.json',     icon: '📧' },
      { id: 'label',           name: 'Labels',          file: 'CRM_Label.json',            icon: '🏷️' },
      { id: 'opportunity',     name: 'Opportunity',     file: 'CRM_Opportunity.json',      icon: '🎯' },
      { id: 'notes',           name: 'Notes',           file: 'CRM_Notes.json',            icon: '📌' },
    ],
  },
  {
    id: 'auth',
    name: 'Auth API Reference',
    submodules: [
      { id: 'auth',    name: 'Auth Endpoints', file: 'AUTH_Auth.json',    icon: '🔐' },
      { id: 'account', name: 'Account',        file: 'AUTH_Account.json', icon: '👤' },
    ],
  },
  {
    id: 'company',
    name: 'Company',
    submodules: [
      { id: 'company', name: 'Company', file: 'COMPANY_Company.json', icon: '🏢' },
    ],
  },
  {
    id: 'project',
    name: 'Project',
    submodules: [
      { id: 'projects', name: 'Projects', file: 'PROJECT_Projects.json', icon: '📁' },
    ],
  },
  {
    id: 'upload',
    name: 'Upload',
    submodules: [
      { id: 'upload', name: 'Upload', file: 'UPLOAD_Upload.json', icon: '📤' },
    ],
  },
  {
    id: 'event',
    name: 'Networking',
    submodules: [
      { id: 'events', name: 'Events', file: 'EVENT_Events.json', icon: '📅' },
      { id: 'groups', name: 'Groups', file: 'EVENT_Groups.json', icon: '👥' },
    ],
  },
  {
    id: 'survey',
    name: 'Survey',
    submodules: [
      { id: 'survey', name: 'Survey', file: 'SURVEY_Survey.json', icon: '📊' },
    ],
  },
  {
    id: 'automation',
    name: 'Automation',
    submodules: [
      { id: 'templates',      name: 'Templates',              file: 'AUTOMATION_Templates.json',     icon: '🗂️' },
      { id: 'scheduletasks',  name: 'Schedule Tasks',         file: 'AUTOMATION_ScheduleTasks.json', icon: '🤖' },
      { id: 'webhooks',       name: 'Webhooks & Triggers',    file: 'AUTOMATION_Webhooks.json',      icon: '⚡' },
    ],
  },
  {
    id: 'telephony',
    name: 'Telephony',
    submodules: [
      { id: 'webhooks', name: 'Webhooks & Call Events', file: 'TELEPHONY_Webhooks.json', icon: '📞' },
    ],
  },
];

export function findSubmodule(moduleId, submoduleId) {
  const mod = modules.find(m => m.id === moduleId);
  if (!mod) return null;
  const sub = mod.submodules.find(s => s.id === submoduleId);
  if (!sub) return null;
  return { module: mod, submodule: sub };
}
